export const vapidKey_v1 =
  "BOJzrEu-3CUWUaSBF_LlNlahQl846xr4_NPdH-8ndcTGqE7QBfOx3nIgoCQohiwqzb5VmdhXxrlfIT7LLAW9dMU";
/** Load region default **/
export const listURL = {
  MobileDEV: {
    id: 13,
    urlAPI: "https://mobiledev2.namlongtekgroup.com",
    urlImage: "https://imgsmartcity.namlongtekgroup.com/",
    defaultMap: {
      url: "https://{s}.google.com/vt/lyrs=m&x={x}&y={y}&z={z}",
      // url: "https://thuduc-maps.hcmgis.vn/thuducserver/gwc/service/wmts?layer=thuduc:thuduc_maps&style=&tilematrixset=EPSG:900913&Service=WMTS&Request=GetTile&Version=1.0.0&Format=image/png&TileMatrix=EPSG:900913:{z}&TileCol={x}&TileRow={y}",
      min: 1,
      max: 21,
      zoom: 6,
    },
    defaultMiniMap: {
      url: "https://{s}.google.com/vt/lyrs=s&x={x}&y={y}&z={z}",
      min: 1,
      max: 21,
      zoom: 2,
    },
    vapidKey: vapidKey_v1,
    server: "SXDCT",
  },
  Control: {
    id: 14,
    urlAPI: "https://control-api.nlt-group.com",
    urlImage: "https://imgsmartcity.namlongtekgroup.com/",
    defaultMap: {
      url: "https://{s}.google.com/vt/lyrs=m&x={x}&y={y}&z={z}",
      // url: "https://thuduc-maps.hcmgis.vn/thuducserver/gwc/service/wmts?layer=thuduc:thuduc_maps&style=&tilematrixset=EPSG:900913&Service=WMTS&Request=GetTile&Version=1.0.0&Format=image/png&TileMatrix=EPSG:900913:{z}&TileCol={x}&TileRow={y}",
      min: 1,
      max: 21,
      zoom: 6,
    },
    defaultMiniMap: {
      url: "https://{s}.google.com/vt/lyrs=s&x={x}&y={y}&z={z}",
      min: 1,
      max: 21,
      zoom: 2,
    },
    vapidKey: vapidKey_v1,
    server: "SXDCT",
  },
  "Control-2": {
    id: 14,
    urlAPI: "https://apihatangdothi.cantho.gov.vn/",
    urlImage: "https://sharefilehatangdothi.cantho.gov.vn/",
    defaultMap: {
      url: "https://{s}.google.com/vt/lyrs=m&x={x}&y={y}&z={z}",
      // url: "https://thuduc-maps.hcmgis.vn/thuducserver/gwc/service/wmts?layer=thuduc:thuduc_maps&style=&tilematrixset=EPSG:900913&Service=WMTS&Request=GetTile&Version=1.0.0&Format=image/png&TileMatrix=EPSG:900913:{z}&TileCol={x}&TileRow={y}",
      min: 3,
      max: 21,
      zoom: 10,
    },
    defaultMiniMap: {
      url: "https://{s}.google.com/vt/lyrs=s&x={x}&y={y}&z={z}",
      min: 3,
      max: 21,
      zoom: 10,
    },
    vapidKey: vapidKey_v1,
    server: "SXDCT",
    urlLogo: "/assets/image/NLT-INFO/nlt_logo.svg",
    urlLogo: "/assets/image/NLT-INFO/cayxanh_logo.svg",
    urlLogoDEV: "/assets/image/NLT-INFO/nlt-text-logo.svg",
    urlLogoDEV: "/assets/image/NLT-INFO/cayxanh-text-logo.svg",

  },
  Localhost: {
    id: 15,
    // urlAPI: "http://192.168.1.100:3081/",
    urlAPI: "https://webapi-dsvn.nlt-group.com:9002/",
    urlImage: "https://imgsmartcity.namlongtekgroup.com/",
    defaultMap: {
      url: "https://{s}.google.com/vt/lyrs=m&x={x}&y={y}&z={z}",
      // url: "https://thuduc-maps.hcmgis.vn/thuducserver/gwc/service/wmts?layer=thuduc:thuduc_maps&style=&tilematrixset=EPSG:900913&Service=WMTS&Request=GetTile&Version=1.0.0&Format=image/png&TileMatrix=EPSG:900913:{z}&TileCol={x}&TileRow={y}",
      min: 1,
      max: 21,
      zoom: 6,
    },
    defaultMiniMap: {
      url: "https://{s}.google.com/vt/lyrs=s&x={x}&y={y}&z={z}",
      min: 1,
      max: 21,
      zoom: 2,
    },
    vapidKey: vapidKey_v1,
    server: "SE07_01",
  },
};
